/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * What `POST /transactions/{id}/reengage` would do, for the confirm dialog.
 * @export
 * @interface ReengagePreviewResponse
 */
export interface ReengagePreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof ReengagePreviewResponse
     */
    toStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ReengagePreviewResponse
     */
    emailRecipient?: string;
}

/**
 * Check if a given object implements the ReengagePreviewResponse interface.
 */
export function instanceOfReengagePreviewResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "toStatus" in value;

    return isInstance;
}

export function ReengagePreviewResponseFromJSON(json: any): ReengagePreviewResponse {
    return ReengagePreviewResponseFromJSONTyped(json, false);
}

export function ReengagePreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReengagePreviewResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'toStatus': json['to_status'],
        'emailRecipient': !exists(json, 'email_recipient') ? undefined : json['email_recipient'],
    };
}

export function ReengagePreviewResponseToJSON(value?: ReengagePreviewResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to_status': value.toStatus,
        'email_recipient': value.emailRecipient,
    };
}

